import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import React, { useContext, useEffect, useCallback, useMemo } from 'react';
import { logDeprecationMessage } from '@jutro/platform';
import { ThemeContext } from '@jutro/theme';
import { DropdownSelectField } from '../../inputs/DropdownSelectField/DropdownSelectField';
import { themeChooserPropTypes, themeChooserDefaultProps } from './propTypes';
const isThemeContextValue = theme => 'switchTheme' in theme;
export const ThemeChooser = ({
  id,
  availableThemes,
  theme: themeInput,
  defaultTheme,
  onThemeChange,
  className,
  label,
  storybookComponent,
  skipPropagation: isValueControlledOutside,
  readOnly,
  hideLabel,
  internalClassNames,
  alwaysShowPlaceholder,
  searchable,
  isInitiallyOpen,
  controlClassName,
  secondaryLabel,
  tooltip,
  placeholder,
  required,
  schemaRequired,
  disabled,
  nullable,
  visible,
  onValidationChange,
  onBlur,
  onFocus,
  showErrors,
  showRequired,
  showOptional,
  layout,
  labelClassName,
  secondaryLabelClassName,
  gwTest,
  showValidationIcon,
  requiredFieldValidationMessage,
  successMessage,
  messageProps,
  labelPosition,
  phone,
  phoneWide,
  tablet
}) => {
  const themeContextConfig = useContext(ThemeContext);
  const themeInputConfig = useMemo(() => isValueControlledOutside && _findInstanceProperty(availableThemes).call(availableThemes, ({
    name
  }) => name === (themeInput && themeInput.name)), [themeInput]);
  const theme = themeInputConfig || themeContextConfig;
  useEffect(() => {
    _forEachInstanceProperty(availableThemes).call(availableThemes, ({
      dropTarget,
      name
    }) => {
      if (!dropTarget) {
        return;
      }
      logDeprecationMessage(`ThemeChooser: ${name} Theme`, undefined, undefined, dropTarget);
    });
  }, [availableThemes]);
  const availableThemesOptions = useMemo(() => _mapInstanceProperty(availableThemes).call(availableThemes, ({
    name
  }) => ({
    displayName: name,
    id: name
  })), [availableThemes]);
  const handleOnChange = useCallback(themeName => {
    const newTheme = _findInstanceProperty(availableThemes).call(availableThemes, themeItem => themeItem.name === themeName);
    if (!newTheme) {
      return;
    }
    if (onThemeChange) {
      onThemeChange(newTheme);
    }
    if (!isValueControlledOutside && isThemeContextValue(theme)) {
      theme.switchTheme(newTheme);
    }
  }, [onThemeChange, availableThemes, theme]);
  if (storybookComponent) {
    const StorybookComponent = storybookComponent;
    return React.createElement(StorybookComponent, {
      id: id,
      className: className,
      onThemeChange: onThemeChange,
      theme: theme,
      availableThemes: availableThemes,
      label: label,
      skipPropagation: isValueControlledOutside
    });
  }
  const defaultValue = defaultTheme ? {
    id: defaultTheme.name,
    displayName: defaultTheme.name
  } : undefined;
  const dropdownSelectProps = {
    id,
    className,
    label,
    hideLabel,
    readOnly,
    internalClassNames,
    alwaysShowPlaceholder,
    searchable,
    isInitiallyOpen,
    controlClassName,
    secondaryLabel,
    tooltip,
    placeholder,
    required,
    schemaRequired,
    disabled,
    nullable,
    visible,
    onValidationChange,
    onBlur,
    onFocus,
    showErrors,
    showRequired,
    showOptional,
    layout,
    labelClassName,
    secondaryLabelClassName,
    gwTest,
    showValidationIcon,
    requiredFieldValidationMessage,
    successMessage,
    messageProps,
    labelPosition,
    phone,
    phoneWide,
    tablet,
    defaultValue
  };
  return React.createElement(DropdownSelectField, _extends({
    availableValues: availableThemesOptions,
    value: theme.name,
    onValueChange: handleOnChange
  }, dropdownSelectProps));
};
ThemeChooser.propTypes = themeChooserPropTypes;
ThemeChooser.defaultProps = themeChooserDefaultProps;
ThemeChooser.displayName = 'ThemeChooser';
ThemeChooser.__docgenInfo = {
  componentName: "ThemeChooser",
  packageName: "@jutro/components",
  description: "Component that allows the user to select the theme configuration",
  displayName: "ThemeChooser",
  methods: [],
  actualName: "ThemeChooser",
  metadataType: "element",
  composes: ["./propTypes"]
};